module.exports = __webpack_public_path__ + "img/technology_icon_07.864f5bcb.png";